import type { OrganizationForgottenByEmailRequestModel } from 'ab-requestModels/organizationForgotten.requestModel';

import { EMAIL_REGEX } from '@acceligentllc/shared/constants/regex';

export default function validate(values: OrganizationForgottenByEmailRequestModel) {

	const errors: ValidationErrors = {};

	if (!values.email) {
		errors.email = 'Email is required';
	} else if (!EMAIL_REGEX.test(values.email)) {
		errors.email = 'Invalid email address';
	}

	return errors;
}
